import { Navigate } from 'react-router';

import { paths } from 'src/routes/paths';

import { useAuthContext } from 'src/auth/hooks';
import { isHqTenantCode } from 'src/auth/utils';

// ----------------------------------------------------------------------

/**
 * 登录后按租户跳转默认首页
 * - 总部（code=0000）：平台工作台
 * - 加盟商：资产管理（业务菜单首项）
 */
export function RoleScopeRedirect({ redirectTo }: { redirectTo?: string }) {
  const { user } = useAuthContext();

  const target =
    redirectTo || (isHqTenantCode(user?.tenantCode) ? paths.hq.overview : paths.dashboard.root);

  return <Navigate to={target} replace />;
}
